export const camelSnakeKebabToSpaces = (input: string) => {
  const words = input.replace(/([a-z])([A-Z])/g, '$1 $2').split(/[\s_-]+/);

  return words.join(' ');
};
